export function getCookie(name) {
  var cookies = document.cookie.split('; ');
  for (var i = 0; i < cookies.length; i++) {
    var [key, value] = cookies[i].split('=');
    if (key === name) {
      return value;
    }
  }
  return undefined;
}
export function setCookie(name, value, maxAge) {
  var cookieStr = `${name}=${value}; path=/;`;
  if (maxAge) {
    cookieStr += ` max-age=${maxAge};`;
  }
  document.cookie = cookieStr;
}